const namespace = {
  sidebar: {
    ariaLabel: "Scores menu",
    header: {
      title: "Categories",
      backAction: "Back to menu",
      toggle: {
        ariaLabel: "Toggle sidebar",
        ariaLabel_open: "Open sidebar",
        ariaLabel_close: "Close sidebar",
      },
    },
  },
  categoriesToggle: {
    toggleLabel: "Categories",
    backAction: "Back",
  },
  categories: {
    transport: "Transport",
    amenities: "Amenities",
    character: "Character",
    nature: "Nature",
    education: "Education",
    health: "Health",
  },
  scoreComparison: {
    text: "Comparable to the {{name}} average of {{value}}",
    text_higher: "Higher than the {{name}} average of {{value}}",
    text_lower: "Lower than the {{name}} average of {{value}}",
  },
  poiSearchRadius: "Showing POIs in a {{radius}} {{unit}} radius",
  commute: {
    placeholder: "Search map...",
    clearSearch: "Clear search",
    resultsCount_one: "{{count}} result available.",
    resultsCount_other: "{{count}} results available.",
    cta: "Calculate commute",
    cta_long: "Calculate commute",
    cta_short: "Calculate",
    viewRoute: "View route",
    travelTypeAriaLabel: "Commute type",
    travelTypes: {
      walking: "Walking",
      driving: "Driving",
      cycling: "Cycling",
    },
    results: {
      noRoute: "No route available.",
      trySuggestion: "Try another query.",
      fastestRoute: "Fastest route",
    },
  },
} as const;

export default namespace;
